export enum Services {
  SINGLE_AUTH = 'community'
}
